export default __webpack_public_path__ + "static/media/sorteo_movil.9eb0be66.png";